var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("wine", {
    attrs: {
      idWine: _vm.idWine,
      loggedUserData: _vm.loggedUserData,
      searchCriterias: this.searchCriterias,
      returnRoute: _vm.returnRoute,
      paramRoute: _vm.routeParam,
      cellarWine: _vm.cellarWine
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };